var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5722 10.241C11.5751 9.15524 12.2008 7.70143 12.2008 6.10042C12.2008 2.74196 9.46807 0 6.10042 0C2.73277 0 0 2.74196 0 6.10042C0 9.45888 2.73277 12.2008 6.10042 12.2008C7.47141 12.2008 8.73196 11.75 9.7533 10.9863L14.2895 15.5225C14.3999 15.6329 14.5379 15.6881 14.6759 15.6881C14.814 15.6881 14.9612 15.6329 15.0624 15.5225C15.274 15.3108 15.274 14.9612 15.0624 14.7404L10.5722 10.241ZM1.10415 6.10042C1.10415 3.34924 3.34005 1.10415 6.10042 1.10415C8.8516 1.10415 11.0967 3.34005 11.0967 6.10042C11.0967 8.86079 8.86079 11.0967 6.10042 11.0967C3.34005 11.0967 1.10415 8.8516 1.10415 6.10042Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.ccc1b7c2758ccaf1288fd16faf4e137d.svg";
export { ForwardRef as ReactComponent };